






















































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator';
import {getPrintImageSize, PrintImages, PrintImageSizes} from '@/types/Print-Images';
import html2canvas from 'html2canvas';
import {FontFamilyType} from '@/types/font-familys';

interface PrintSelect {
  name: any;
  value: string;
}

interface FontStyle {
  fontFamily: string;
  fontWeight: number;
  lineHeight: number;
  fontSize: number;
  letterSpacing: number;
}

interface BackgroundStyle {
  width: number;
  height: number;
  backgroundImage: string;
}

const fontStyleDefault: FontStyle = {
  fontFamily: FontFamilyType['宋体'],
  fontWeight: 600,
  fontSize: 14,
  lineHeight: 14,
  letterSpacing: 0
};

@Component
export default class PrintView extends Vue {


  /*字体设置*/
  private fontStyle: FontStyle = fontStyleDefault;
  /*背景设置*/
  private backgroundStyle: BackgroundStyle = {
    width: 0,
    height: 0,
    backgroundImage: ''
  };

  /*字体下拉列表*/
  private familyArray: Array<PrintSelect> = [];
  /*字体下拉列表*/
  private printImagesArray: Array<PrintSelect> = [];
  private editFontId: string = '';
  @Ref('printView')
  private printView!: HTMLElement;


  mounted() {
    this.getFamilyArray();
    this.getBackgroundImage();
    this.$nextTick(() => {
      this.backgroundStyle.width = this.printView.clientWidth;
      this.backgroundStyle.height = this.printView.offsetHeight;
    });
    this.$forceUpdate();
  }


  /**
   * 读取拖拽文件
   */
  public tableBeforeUpload(file: File, fileList: Array<File>): boolean {
    return false;
  }

  /**
   * 样式单位初始化
   * @param unit 单位类型
   */
  public fontStyleUnitInit(unit: 'px' | 'rem' | 'em' | 'vh' | 'vw' | '%') {
    let fontStyle = JSON.parse(JSON.stringify(this.fontStyle));
    fontStyle.fontFamily = this.fontStyle.fontFamily;
    fontStyle.fontSize = this.fontStyle.fontSize + 'px';
    fontStyle.fontWeight = this.fontStyle.fontWeight;
    fontStyle.letterSpacing = this.fontStyle.letterSpacing + 'px';
    fontStyle.lineHeight = this.fontStyle.lineHeight + 'px';
    return fontStyle;
  }

  /**
   * 刷新字体样式
   */
  public tickFontStyle(): void {
    let tmp: any = this.$refs['fontTemplate'];
    let element: any = this.$refs[this.editFontId];
    let tmpStyle: CSSStyleDeclaration = tmp.style;
    tmpStyle = Object.assign(tmpStyle, this.fontStyleUnitInit('px'));
    if (this.editFontId) {    //设置数据大小
      let style: CSSStyleDeclaration = element.style;
      style = Object.assign(style, this.fontStyleUnitInit('px'));
    }

  }

  /**
   * 设置字体
   */
  public fontStyleSetting($event: MouseEvent) {
    let target: HTMLElement | any = $event.target;
    this.editFontId = target.id;  //设置编辑id
    let {fontSize, fontFamily, lineHeight, fontWeight, letterSpacing} = target.style;
    this.fontStyle = Object.assign({},
      {
        fontSize: fontSize.split('px')[0] ? +fontSize.split('px')[0] : false || fontStyleDefault.fontSize,
        fontFamily: fontFamily || fontStyleDefault.fontFamily,
        lineHeight: lineHeight.split('px')[0] ? +lineHeight.split('px')[0] : false || fontStyleDefault.lineHeight,
        fontWeight: fontWeight || fontStyleDefault.fontWeight,
        letterSpacing: letterSpacing.split('px')[0] ? +letterSpacing.split('px')[0] : false || fontStyleDefault.letterSpacing
      });
    this.tickFontStyle();
  }


  /**
   * 数据移动开始
   */
  public dasMouseDown($evnent: MouseEvent | any) {
    let target: EventTarget | any = $evnent.target;
    arguments[0].preventDefault();
    let disX = arguments[0].clientX - document.getElementById(target.id)!.offsetLeft;
    let disY = arguments[0].clientY - document.getElementById(target.id)!.offsetTop;
    document.onmousemove = function() {
      document.getElementById(target.id)!.style.left = arguments[0].clientX - disX + 'px';
      document.getElementById(target.id)!.style.top = arguments[0].clientY - disY + 'px';
    };
    document.onmouseup = function() {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }

  /**
   * 拖动开始事件
   */
  public dragstart_handler(ev: DragEvent | any) {
    ev.dataTransfer.setData('id', ev.target.id);
  }


  /**
   * 放入事件
   */
  public dragover_handler(ev: DragEvent | any) {
    // console.log('Drop');
    ev.preventDefault();
  }

  public move_handler($evnent: DragEvent | any) {
    let target: EventTarget | any = $evnent.target;
    let {pageX, pageY} = $evnent;
    document.getElementById(target.id)!.setAttribute('style', 'position: fixed;'.concat('left:').concat(pageX).concat(';').concat('top:').concat(pageY).concat(';'));
  }

  public drop_handler(ev: any) {

  }


  /**
   * 开始打印
   */
  public printStart() {
    html2canvas(document.getElementById('print-view')!, {
      backgroundColor: 'transparent',
      allowTaint: true,
      useCORS: true
    }).then(canvas => {
      let oImg = new Image();
      oImg.src = canvas.toDataURL();
      this.$print({printable: canvas.toDataURL(), type: 'image'});
    });

  }


  /**
   * 获取字体列表
   */
  public getFamilyArray() {
    let familyArray: Array<PrintSelect> = [];

    Object.assign(this.familyArray, familyArray);
  }

  /**
   * 获取背景模板
   */
  public getBackgroundImage() {
    let printImagesArray: Array<PrintSelect> = [];
    Object.keys(PrintImages).forEach((imageName: string) => {
      printImagesArray.push({
        name: imageName,
        // @ts-ignore
        value: PrintImages[imageName]
      });
    });
    Object.assign(this.printImagesArray, printImagesArray);
  }

  /**
   * 模板下拉变化事件
   */
  public backgroundSelectChange(image: string) {
    // @ts-ignore
    let size = PrintImageSizes[image];
    let {width, height} = getPrintImageSize(size);
    //设置背景高度和宽度
    this.backgroundStyle.width = width;
    this.backgroundStyle.height = height;
    this.backgroundStyle.backgroundImage = image;
    // this.backgroundStyle.backgroundImage = 'url(\''.concat(image).concat('\')');
  }


  // 计算属性
  get computedMsg(): any {
    return null;
  }


}
